import React from 'react';
import { useParams } from 'react-router';
import { useQuery } from '@tanstack/react-query';
import { DocRequestView } from '@/components';
import { useDispatch } from 'react-redux';
import { entitiesActions } from '@/store/entities';
import { adminKYCApi } from '@/api/admin/kyc';
import { useTranslation } from 'react-i18next';
import { usePopups, useLoadingState } from '@/hooks';
import { STATUS } from '@/utils/static/kyc';

export const InvestorDocRequest = () => {
  const { t } = useTranslation();
  const { id, requestId } = useParams();
  const { hideLoader, showErrorToast } = usePopups();
  const dispatch = useDispatch();
  const { data, refetch, isFetching } = useQuery({
    queryKey: ['getDocumentRequest'],
    queryFn: () => adminKYCApi.getDocumentRequest({ investorId: id, requestId })
  });

  useLoadingState(isFetching, 'Loading');

  const approveRequest = async (docId) => updateRequestStatus(docId, STATUS.PASSED);
  const rejectRequest = async (docId) => updateRequestStatus(docId, STATUS.REJECTED);
  const updateRequestStatus = async (docId, status) => {
    try {
      dispatch(
        entitiesActions.showLoader(
          status === STATUS.PASSED ? t('Approving') + '...' : t('Rejecting') + '...'
        )
      );
      await adminKYCApi.updateRequestStatus({ kycDocumentId: docId, status });
      await refetch();
    } catch (e) {
      console.error(e);
      showErrorToast(e, true);
    } finally {
      hideLoader();
    }
  };

  return (
    <DocRequestView
      isFetching={isFetching}
      data={data}
      refetch={refetch}
      requestId={requestId}
      investorId={id}
      viewMode={'admin'}
      approveRequest={approveRequest}
      rejectRequest={rejectRequest}
    />
  );
};
